/* w9-gearing — Gearing guide for sprocket products (2026-09-24).
   Ratio maths only: torque at the wheel scales with rear/front, top speed (at the same RPM) with the inverse,
   and the rear tire's overall diameter acts like a hidden sprocket change. Works for gas and electric alike.
   Reads the tooth counts from the product's own option values and keeps the slider in step with the
   buy box's size dropdown (the theme's <variant-selects>). Nothing here knows which bike it is. */
(function () {
  'use strict';
  if (window.__w9g) return; window.__w9g = 1;

  var TOOTH = /(\d{1,3})\s*(?:T\b|TOOTH|TEETH)/i, NUM = /^\s*(\d{1,3})\s*$/;
  var REAR_GENERIC = [38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64], FRONT_GENERIC = [12, 13, 14, 15, 16];
  function teethOf(v) { if (v == null) return null; var m = TOOTH.exec(String(v)) || NUM.exec(String(v)); return m ? parseInt(m[1], 10) : null; }
  function money(cents) { var s = (cents / 100).toFixed(2); return '$' + s.replace(/\.00$/, ''); }
  function pct(x) { return (x >= 0 ? '+' : '−') + Math.abs(x).toFixed(1) + '%'; }
  function pct0(x) { return Math.abs(x) < 0.05 ? '—' : (x > 0 ? '+' : '−') + Math.abs(x).toFixed(0) + '%'; }
  function fmtLinks(n) { var a = Math.abs(n); if (a < 0.5) return 'same chain'; return 'about ' + (a % 1 ? a.toFixed(1) : a) + ' link' + (a === 1 ? '' : 's') + (n > 0 ? ' longer' : ' shorter'); }
  function od(w, a, r) { return r * 25.4 + 2 * w * a / 100; }
  function nearest(list, x) { return list.reduce(function (p, c) { return Math.abs(c - x) < Math.abs(p - x) ? c : p; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    var jsonEl = root.querySelector('[data-w9g-json]'); if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var options = data.options || [], variants = data.variants || [];
    if (!variants.length) return;

    // the tooth option: every distinct value parses as a tooth count
    var ti = -1, bestN = 0;
    options.forEach(function (name, i) {
      var seen = {}; variants.forEach(function (v) { seen[v.o[i]] = 1; });
      var keys = Object.keys(seen), n = keys.filter(function (k) { return teethOf(k) !== null; }).length;
      if (keys.length && n === keys.length && n > bestN) { bestN = n; ti = i; }
    });
    if (ti < 0) return;                      // not a sprocket with sizes: stay hidden

    var byTeeth = {};                        // teeth -> { value, minPrice, available }
    variants.forEach(function (v) {
      var t = teethOf(v.o[ti]); if (t === null) return;
      var e = byTeeth[t] || (byTeeth[t] = { value: v.o[ti], minPrice: null, available: false });
      if (e.minPrice === null || v.p < e.minPrice) e.minPrice = v.p;
      if (v.a) e.available = true;
    });
    var productSteps = Object.keys(byTeeth).map(Number).sort(function (a, b) { return a - b; });
    if (productSteps.length < 1) return;

    var kind = root.getAttribute('data-kind') === 'front' ? 'front' : 'rear';
    var defFront = parseInt(root.getAttribute('data-default-front'), 10) || 13;
    var defRear = parseInt(root.getAttribute('data-default-rear'), 10) || 48;
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // the buy box control for the tooth option
    var picker = document.querySelector('variant-selects, variant-radios');
    var selects = picker ? Array.prototype.slice.call(picker.querySelectorAll('select')) : [];
    var sel = selects.filter(function (s) { return s.name === 'options[' + options[ti] + ']'; })[0] || null;
    var radios = !sel && picker ? Array.prototype.slice.call(picker.querySelectorAll('input[type=radio][name="' + options[ti].replace(/"/g, '\\"') + '"]')) : [];
    function pickedTeeth() {
      if (sel) return teethOf(sel.value);
      var r = radios.filter(function (x) { return x.checked; })[0]; if (r) return teethOf(r.value);
      var v = variants.filter(function (x) { return x.a; })[0] || variants[0]; return teethOf(v.o[ti]);
    }
    var pageTeeth = pickedTeeth(); if (pageTeeth === null || byTeeth[pageTeeth] === undefined) pageTeeth = productSteps[0];

    var state = {
      mode: kind,                                        // which sprocket the slider changes
      curFront: kind === 'front' ? pageTeeth : defFront, // what is on the bike now
      curRear: kind === 'rear' ? pageTeeth : defRear,
      newRear: kind === 'rear' ? pageTeeth : defRear,    // the choice on the slider
      newFront: kind === 'front' ? pageTeeth : defFront,
      touched: false
    };
    var syncing = false;

    function steps() { return state.mode === kind ? productSteps : (state.mode === 'rear' ? REAR_GENERIC : FRONT_GENERIC); }

    // buy box -> slider
    function fromBuyBox() {
      var t = pickedTeeth(); if (t === null) return;
      if (kind === 'rear') state.newRear = t; else state.newFront = t;
      render();
    }
    // slider -> buy box (only for the sprocket this product sells)
    function toBuyBox(t) {
      var e = byTeeth[t]; if (!e || syncing) return;
      syncing = true;
      try {
        if (sel) {
          var has = Array.prototype.some.call(sel.options, function (o) { return o.value === e.value; });
          if (!has) {
            // the theme's cascade dropped this size for the current material: switch the earlier dropdown(s) to a variant that has it
            var v = variants.filter(function (x) { return x.o[ti] === e.value && x.a; })[0] || variants.filter(function (x) { return x.o[ti] === e.value; })[0];
            if (v) selects.forEach(function (s, i) { if (i < ti && s.value !== v.o[i]) { s.value = v.o[i]; s.dispatchEvent(new Event('change', { bubbles: true })); } });
          }
          if (sel.value !== e.value) { sel.value = e.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        } else if (radios.length) {
          var r = radios.filter(function (x) { return x.value === e.value; })[0];
          if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      } finally { syncing = false; }
    }
    if (picker) picker.addEventListener('change', function () { if (!syncing) setTimeout(fromBuyBox, 0); });

    // tire inputs (optional block)
    var tire = $('[data-w9g-tire]');
    function tin(k) { return $('[data-w9g-t="' + k + '"]'); }
    function tval(k) { var i = tin(k); return i ? +i.value : 0; }
    function rowFull(n) { return tval(n + 'w') > 0 && tval(n + 'a') > 0 && tval(n + 'r') > 0; }

    function render() {
      var rearMode = state.mode === 'rear', st = steps();
      var newRear = rearMode ? state.newRear : state.curRear;      // the sprocket not being changed stays as it is
      var newFront = rearMode ? state.curFront : state.newFront;
      if (rearMode && st.indexOf(newRear) < 0) newRear = nearest(st, newRear);
      if (!rearMode && st.indexOf(newFront) < 0) newFront = nearest(st, newFront);
      var idx = st.indexOf(rearMode ? newRear : newFront);

      $$('[data-w9g-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-w9g-tab') === state.mode)); });
      $('[data-w9g-out="curFront"]').textContent = state.curFront; $('[data-w9g-out="curRear"]').textContent = state.curRear;
      $('[data-w9g-newlbl]').textContent = rearMode ? 'New rear sprocket' : 'New front (countershaft / jackshaft) sprocket';
      var range = $('[data-w9g-range]'); range.max = st.length - 1; range.value = idx;
      var prefill = $('[data-w9g-prefill]');
      prefill.textContent = state.touched ? 'Comparing against ' + state.curFront + ' / ' + state.curRear + ', the gearing you entered.'
        : 'Prefilled with the size on this page and a typical ' + (kind === 'rear' ? defFront + '-tooth front' : defRear + '-tooth rear') + '. Change them to match your bike; the numbers update as you go.';

      // rear tire overall diameter; the front wheel plays no part
      var tireOn = !!(tire && tire.open), tireOk = false, tireK = 1, od0 = 0, od1 = 0;
      if (tire) {
        od0 = od(tval('0w'), tval('0a'), tval('0r')); od1 = od(tval('1w'), tval('1a'), tval('1r'));
        var f0 = rowFull(0), f1 = rowFull(1);
        $('[data-w9g-od="0"]').textContent = f0 && od0 > 200 ? '= ' + Math.round(od0) + ' mm (' + (od0 / 25.4).toFixed(1) + '")' : '';
        $('[data-w9g-od="1"]').textContent = f1 && od1 > 200 ? '= ' + Math.round(od1) + ' mm (' + (od1 / 25.4).toFixed(1) + '")' : '';
        tireOk = tireOn && f0 && f1 && od0 > 200 && od1 > 200;
        tireK = tireOk ? od0 / od1 : 1;
        var ts = $('[data-w9g-tiresay]'); ts.innerHTML = '';
        if (tireOk) {
          var dOD = (od1 / od0 - 1) * 100, eqTeeth = state.curRear * tireK - state.curRear, keep = state.curRear / tireK;
          if (Math.abs(dOD) < 0.3) ts.textContent = 'Same overall diameter, so the tire change does not alter your gearing.';
          else {
            var near = nearest(kind === 'rear' ? productSteps : REAR_GENERIC, keep);
            ts.innerHTML = 'The new tire is <b>' + Math.abs(dOD).toFixed(1) + '% ' + (dOD < 0 ? 'smaller' : 'taller') + '</b> overall. On its own that is like ' + (eqTeeth > 0 ? 'adding' : 'taking off') + ' about <b>' + Math.abs(eqTeeth).toFixed(1) + ' teeth</b> at the rear' + (eqTeeth > 0 ? ' (more pull, less top speed).' : ' (more top speed, less pull).') +
              ' To keep the feel you have now with this tire you would run about <b>' + keep.toFixed(0) + 'T</b>' + (kind === 'rear' ? '; nearest size made: <button class="w9g__chip w9g__chip--strong" type="button" data-w9g-keep="' + near + '">' + near + 'T</button>' : '.');
            var kb = ts.querySelector('[data-w9g-keep]');
            if (kb) kb.addEventListener('click', function () { state.mode = 'rear'; state.newRear = near; toBuyBox(near); render(); });
          }
        }
      }

      var oldRatio = state.curRear / state.curFront, newRatio = newRear / newFront;
      var torque = ((newRatio / oldRatio) * tireK - 1) * 100, speed = ((oldRatio / newRatio) / tireK - 1) * 100;

      // ticks: every size, each with its pull % against the bike as it is now
      var ticks = $('[data-w9g-ticks]'); ticks.innerHTML = ''; ticks.classList.toggle('is-dense', st.length > 11);
      st.forEach(function (t, i) {
        var s = document.createElement('span'); s.style.left = (i / Math.max(1, st.length - 1) * 100) + '%';
        var tq = rearMode ? ((t / newFront) / oldRatio * tireK - 1) * 100 : ((newRear / t) / oldRatio * tireK - 1) * 100;
        s.innerHTML = t + 'T<span class="w9g__p ' + (tq > 0.05 ? 'up' : tq < -0.05 ? 'dn' : '') + '">' + pct0(tq) + '</span>';
        if (t === (rearMode ? newRear : newFront)) s.className = 'is-cur';
        if (t === (rearMode ? state.curRear : state.curFront) && Math.abs(tq) < 0.05) s.className += ' is-now';
        ticks.appendChild(s);
      });
      var thumb = $('[data-w9g-thumb]'), e = state.mode === kind ? byTeeth[rearMode ? newRear : newFront] : null;
      thumb.textContent = (rearMode ? newRear : newFront) + 'T' + (e && e.minPrice !== null ? ' · from ' + money(e.minPrice) : '') + (e && !e.available ? ' · sold out' : '');
      var p = st.length > 1 ? idx / (st.length - 1) : 0.5;
      thumb.style.left = 'calc(19px + ' + p + ' * (100% - 38px))';

      var tv = $('[data-w9g-torque]'), sv = $('[data-w9g-speed]'); tv.textContent = pct(torque); sv.textContent = pct(speed);
      $('[data-w9g-ro="torque"]').classList.toggle('is-up', torque > 0.05); $('[data-w9g-ro="speed"]').classList.toggle('is-up', speed > 0.05);
      var m = Math.max(-1, Math.min(1, torque / 35)); $('[data-w9g-mark]').style.left = (50 + m * 50) + '%';

      var say, sameGear = newRear === state.curRear && newFront === state.curFront;
      var tireTxt = tireOk ? ' on a ' + tval('1w') + '/' + tval('1a') + '-' + tval('1r') + ' rear tire' : '';
      if (Math.abs(torque) < 0.05) {
        say = sameGear && !tireOk ? 'That is the gearing you have now: <b>' + state.curFront + ' / ' + state.curRear + '</b>. Drag the slider, or pick another size above, to compare.'
          : 'Sprocket and tire cancel out: <b>' + newFront + ' / ' + newRear + esc(tireTxt) + '</b> feels like your bike does today.';
      } else {
        var links = rearMode ? (newRear - state.curRear) / 2 : (newFront - state.curFront) / 2;
        var revsUp = Math.round(Math.abs(speed) / (1 - Math.abs(speed) / 100));
        say = '<b>' + state.curFront + ' / ' + state.curRear + ' → ' + newFront + ' / ' + newRear + esc(tireTxt) + '.</b> ' +
          (torque > 0
            ? 'About <b>' + Math.round(torque) + '% more pull</b> in every gear, and about <b>' + Math.round(Math.abs(speed)) + '% lower top speed</b> at the same RPM (or ' + revsUp + '% more revs at the same road speed).'
            : 'About <b>' + Math.round(speed) + '% more top speed</b> at the same RPM (or ' + Math.round(Math.abs(torque)) + '% fewer revs at the same road speed), with about <b>' + Math.round(Math.abs(torque)) + '% less pull</b> in every gear.') +
          ' Chain: ' + fmtLinks(links) + (rearMode && newRear - state.curRear >= 8 ? '; check chain-guide and swingarm clearance.' : '.');
        var hpEl = $('[data-w9g-hp]'), hp = hpEl ? parseFloat(hpEl.value) : NaN;
        if (hp > 0) {
          var eq = hp * (1 + torque / 100);
          say += ' <b>With your ' + hp + ' hp:</b> at any given speed it has the pull of a stock-geared bike with <b>' + (eq % 1 ? eq.toFixed(1) : eq) + ' hp</b>' + (torque > 0 ? '.' : ', so it will feel lazier off the line.');
        }
      }
      $('[data-w9g-say]').innerHTML = say;
      var perTwo = ((state.curRear + 2) / state.curRear - 1) * 100, frontWorth = state.curRear / state.curFront;
      $('[data-w9g-rule]').innerHTML = rearMode
        ? '<b>Rule of thumb for your bike:</b> every 2 teeth on the rear is about ' + perTwo.toFixed(0) + '% more pull and ' + perTwo.toFixed(0) + '% less top speed, or the reverse going smaller. One tooth on the front is worth about ' + frontWorth.toFixed(1) + ' teeth on the rear.'
        : '<b>Rule of thumb for your bike:</b> one tooth on the front is worth about ' + frontWorth.toFixed(1) + ' teeth on the rear. One tooth up front is the cheapest top-speed change; one tooth down adds pull.';
    }

    // wiring
    $('[data-w9g-range]').addEventListener('input', function (e) {
      var st = steps(), t = st[parseInt(e.target.value, 10)] || st[0];
      if (state.mode === 'rear') state.newRear = t; else state.newFront = t;
      if (state.mode === kind) toBuyBox(t);
      render();
    });
    $$('[data-w9g-tab]').forEach(function (b) { b.addEventListener('click', function () { state.mode = b.getAttribute('data-w9g-tab'); render(); }); });
    $$('[data-w9g-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-w9g-step'), d = parseInt(b.getAttribute('data-d'), 10);
        var lo = k === 'curFront' ? 10 : 30, hi = k === 'curFront' ? 20 : 80;
        state[k] = Math.max(lo, Math.min(hi, state[k] + d)); state.touched = true; render();
      });
    });
    var hpEl = $('[data-w9g-hp]'); if (hpEl) hpEl.addEventListener('input', render);
    if (tire) {
      tire.addEventListener('toggle', render);
      $$('[data-w9g-t]').forEach(function (i) { i.addEventListener('input', render); });
      $$('[data-w9g-tchip]').forEach(function (c) {
        c.addEventListener('click', function () {
          var p = c.getAttribute('data-w9g-tchip').split(','), row = rowFull(0) ? '1' : '0';
          tin(row + 'w').value = p[0]; tin(row + 'a').value = p[1]; tin(row + 'r').value = p[2]; render();
        });
      });
    }

    root.hidden = false;
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.w9g[data-w9g]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();